import React from 'react';
import ImgComponent from 'organisms/BrandPage/AU/Presentation/ImgComponent';
import LocalThemeBanner from 'organisms/BrandPage/AU/Presentation/LocalThemeBanner';
import ParaComponent from 'organisms/BrandPage/AU/Presentation/ParaComponent';
import SocialImpactBanner from 'organisms/BrandPage/AU/Presentation/SocialImpactBanner';
import ThreeColumnCardComponent from 'organisms/BrandPage/AU/Presentation/ThreeColumnCardComponent';
import TwoColumnCardComponent from 'organisms/BrandPage/AU/Presentation/TwoColumnCardComponent';
import QuotesComponent from 'organisms/BrandPage/AU/Presentation/QuotesComponent';
import KfcTimelineBanner from 'organisms/BrandPage/AU/Presentation/KfcTimelineBanner';
import StaticBrandPage from 'organisms/BrandPage/Presentation/StaticBrandPage';
import MeetColonelBanner from 'organisms/BrandPage/AU/Presentation/MeetColonelBanner';
import { BrandPageConstant } from 'common/constants/SharedConstants';
import { BrandPageAUTemplates } from 'app/Constants';
import PropTypes from 'prop-types';

const BrandPageContainer = props => {
  const { pageData, routePath } = props;

  const {
    BRAND_PAGE_HERO,
    INTROCOPY,
    FEATURE,
    KEY_FIGURES,
    FEATURE_INTERACTIVE,
    SECTION_LINK_CARDS,
    QUOTES,
    BRAND_PAGE_TEXT,
    SECTION_LINK_HERO,
    STATIC_BRAND_PAGE,
  } = BrandPageConstant;

  const { meetTheColonel, socialImpact } = BrandPageAUTemplates;

  return pageData?.map((item, index) => {
    const { imageAlign = '', body: data, columncontent, scrollRotation = '', description: quote } = item?.fields;
    const id = item?.sys?.contentType?.sys?.id ?? '';
    switch (id) {
      case BRAND_PAGE_HERO:
        return routePath === meetTheColonel ? (
          <MeetColonelBanner data={item?.fields} />
        ) : (
          <SocialImpactBanner data={item?.fields} />
        );
      case INTROCOPY:
      case BRAND_PAGE_TEXT:
        return <ParaComponent data={data || item} />;
      case FEATURE:
        return (
          <ImgComponent
            isPositionRight={imageAlign !== 'Left'}
            scrollRotation={!!scrollRotation}
            data={data}
            isSocialImpactPage={routePath === socialImpact}
            index={index}
          />
        );
      case KEY_FIGURES:
        return <ThreeColumnCardComponent data={columncontent} />;
      case FEATURE_INTERACTIVE:
        return <LocalThemeBanner data={data} />;
      case SECTION_LINK_CARDS:
        return <TwoColumnCardComponent data={data} />;
      case QUOTES:
        return <QuotesComponent text={quote} />;
      case SECTION_LINK_HERO:
        return <KfcTimelineBanner data={item?.fields?.headline} />;
      case STATIC_BRAND_PAGE:
        return <StaticBrandPage data={item?.fields} />;
      default:
        return null;
    }
  });
};

BrandPageContainer.propTypes = {
  routePath: PropTypes.string.isRequired,
  pageData: PropTypes.arrayOf(Object),
};

BrandPageContainer.defaultProps = {
  pageData: [],
};

export default BrandPageContainer;
